export default __webpack_public_path__ + "static/media/referral-svgrepo-com.cd3fb89d.svg";